interface IUpdate {
  labelA: string;
  labelB: string;
  insertOrUpdate?: "update";
  href?: string;
}
interface IInsert {
  labelA: string;
  labelB: string;
  insertOrUpdate: "insert";
  href: string;
}

export interface ABTestDropDownMenu {
  label: string;
  menuItems: (IUpdate | IInsert)[];
}

interface INavMenuItem {
  desktopOnly?: boolean;
  label: string;
  href?: string;
  icon?: string;
  onClick?: () => void;
}

interface INavbarDropdown {
  label: {
    text: string;
    icon: string;
    smallIcon?: boolean;
  };
  menuItems: INavMenuItem[];
}

export function updateNavStructure(
  content: ABTestDropDownMenu[],
  navStructure: INavbarDropdown[]
) {
  if (!content || !Array.isArray(content)) {
    return navStructure;
  }

  const labelMenuItemMap = content.reduce((labelMenuItemAcc, currentValue) => {
    labelMenuItemAcc[currentValue.label] = currentValue.menuItems;
    return labelMenuItemAcc;
  }, {});

  return navStructure.reduce((newNavStructureAcc, currentNav) => {
    const testMenuItems = labelMenuItemMap[currentNav.label.text];
    if (testMenuItems) {
      const { label, menuItems: currentNavMenuItems } = currentNav;

      const updatedMenuItems = currentNavMenuItems.reduce(
        (menuItemsAcc, menuItemsCurrentVal) => {
          const menuItemToBeChanged = testMenuItems.filter(
            (testMenuItem) => testMenuItem.labelA === menuItemsCurrentVal.label
          );

          if (menuItemToBeChanged.length === 0) {
            menuItemsAcc.push(menuItemsCurrentVal);
          } else {
            // Insert new menu item
            // eslint-disable-next-line no-lonely-if
            if (menuItemToBeChanged[0].insertOrUpdate === "insert") {
              menuItemsAcc.push(menuItemsCurrentVal);
              menuItemsAcc.push({
                label: menuItemToBeChanged[0].labelB,
                href: menuItemToBeChanged[0].href,
              });
            } else if (menuItemToBeChanged[0].labelB) {
              // Update the existing menu item
              menuItemsAcc.push({
                ...menuItemsCurrentVal,
                label: menuItemToBeChanged[0].labelB,
                ...(menuItemToBeChanged[0].href
                  ? { href: menuItemToBeChanged[0].href }
                  : undefined),
              });
            }
          }

          return menuItemsAcc;
        },
        [] as INavMenuItem[]
      );
      newNavStructureAcc.push({ label, menuItems: updatedMenuItems });
    } else {
      newNavStructureAcc.push(currentNav);
    }

    return newNavStructureAcc;
  }, [] as INavbarDropdown[]);
}
